import { render, staticRenderFns } from "./Payroll.vue?vue&type=template&id=64bf0dea&scoped=true"
import script from "./Payroll.vue?vue&type=script&lang=ts"
export * from "./Payroll.vue?vue&type=script&lang=ts"
import style0 from "./Payroll.vue?vue&type=style&index=0&id=64bf0dea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bf0dea",
  null
  
)

export default component.exports